import { TemplateRef } from "@angular/core";
import * as moment from 'moment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Permisos_recepcionesComponent = /** @class */ (function () {
    function Permisos_recepcionesComponent(fb, dialog) {
        this.fb = fb;
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            tipo_permiso: new FormControl(''),
            permiso: new FormControl(''),
            numero: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)]),
            fecha: new FormControl({ value: '', disabled: true })
        });
        if (!JSON.parse(localStorage.getItem("permisos_recepciones"))) {
            localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("permisos_recepciones"));
        }
        this.permisos_recepciones = { tipo_permiso: '', permiso: '', numero: 0, fecha: null };
        this.temp_perm = { tipo_permiso: '', permiso: '', numero: 0, fecha: null };
    }
    Permisos_recepcionesComponent.prototype.add_permisos_recepciones = function () {
        this.actualRow = localStorage.getItem("permisos_recepciones");
        this.rows = JSON.parse(this.actualRow);
        if (!this.form.value.permiso && !this.form.value.numero) {
            console.log("no se ingresaron datos");
        }
        else {
            this.rows = this.rows.concat({
                tipo_permiso: this.form.value.tipo_permiso,
                permiso: this.form.value.permiso,
                numero: this.form.value.numero,
                fecha: moment(this.form.value.fecha).format("DD/MM/YYYY")
            });
            localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
            this.form.reset();
        }
    };
    Permisos_recepcionesComponent.prototype.delete_permisos_recepciones = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
            }
        }
    };
    Permisos_recepcionesComponent.prototype.onChangeSelect = function (event) {
        var value = event.target.value;
        console.log(value);
    };
    Permisos_recepcionesComponent.prototype.get_permisos_recepciones = function (id) {
        console.log(id);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_perm.id = id;
                this.temp_perm.tipo_permiso = this.rows[x].tipo_permiso;
                this.temp_perm.permiso = this.rows[x].permiso;
                this.temp_perm.numero = this.rows[x].numero;
                this.temp_perm.fecha = this.rows[x].fecha;
                console.log(this.temp_perm);
                this.dialog.open(this.openModal);
            }
        }
    };
    Permisos_recepcionesComponent.prototype.cleanData = function () {
        this.temp_perm = { tipo_permiso: '', permiso: '', numero: 0, fecha: null };
    };
    Permisos_recepcionesComponent.prototype.savepermisos_recepciones = function () {
        var id = this.temp_perm.id;
        console.log(this.temp_perm);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("permisos_recepciones");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    tipo_permiso: this.temp_perm.tipo_permiso,
                    permiso: this.temp_perm.permiso,
                    numero: this.temp_perm.numero,
                    fecha: this.temp_perm.fecha
                });
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
                //this.temp_perm.reset();
                this.dialog.closeAll();
            }
        }
    };
    return Permisos_recepcionesComponent;
}());
export { Permisos_recepcionesComponent };
